import { Focusable, useSpatialNavigation } from "@blacknut/spatialnav-sdk/dist";
import clsx from "clsx";
import { UIEvent, useCallback } from "react";
import { NavLink, NavLinkProps } from "react-router-dom";
import { useScrollContext } from "src/utils/scroll/ScrollProvider";
import useAnonymousCheck from "../../utils/useAnonymousCheck";
import styles from "./styles.module.scss";
import React from "react";
import { useAppNavigation } from "src/utils/Navigation/useAppNavigation";

type CompatibilityLayer = { isActive: () => boolean; activeClassName?: string };

const MyNavLink = (
  props: NavLinkProps & {
    linkClassName?: string;
    requiresAnonymousCheck?: boolean;
  } & CompatibilityLayer,
) => {
  const {
    requiresAnonymousCheck = false,
    linkClassName,
    isActive,
    activeClassName,
    to,
    state,
    replace,
  } = props;
  const { checkForAnonymous } = useAnonymousCheck();
  const { active: spatialNavigationActive } = useSpatialNavigation();
  const { clear: clearScrollContext } = useScrollContext();
  const { navigate } = useAppNavigation();
  const onPress = useCallback(
    (e: UIEvent<unknown>) => {
      e.preventDefault();

      const callback = () => {
        clearScrollContext();
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
        navigate(to.toString(), { replace: !!replace, state: state });
      };
      if (requiresAnonymousCheck && checkForAnonymous()) {
        callback();
      } else if (!requiresAnonymousCheck) {
        callback();
      }
    },
    [
      checkForAnonymous,
      clearScrollContext,
      navigate,
      replace,
      requiresAnonymousCheck,
      state,
      to,
    ],
  );
  const {
    linkClassName: _linkClassName,
    requiresAnonymousCheck: _requiresAnonymousCheck,
    isActive: _isActive,
    activeClassName: _activeClassName,
    ...remainingProps
  } = props;

  return (
    <Focusable
      className={clsx([styles.focusable, props.className])}
      onPressEnter={(props.onClick as (e: UIEvent<unknown>) => void) || onPress}
    >
      <NavLink
        onClick={onPress}
        {...remainingProps}
        className={clsx([
          styles.link,
          spatialNavigationActive && styles.spatialActive,
          linkClassName,
          isActive() && (activeClassName ?? styles.active),
        ])}
      >
        {props.children}
      </NavLink>
    </Focusable>
  );
};

export default MyNavLink;
